import React, { useState } from "react";
import { useQuery } from "@apollo/client";
import { GET_ADDRESS_BY_ID } from "../querys";

import {
  Row,
  TextAddress,
  CardAddress,
  ButtonChange,
} from "../components/tabs/components/fields";

import Loading from "../components/Loading";
import { FaRegAddressBook } from "react-icons/fa";

import ModalAddress from "../components/Modal-address";
import {
  ContainerPage,
} from "../components/styled/RegisterMemberStyled";

// Mapeo inverso: de backend a frontend (para mostrar)
const BACKEND_TO_DISPLAY_COUNTRY = {
  "Algeria": "Algeria",
  "Andorra": "Andorra",
  "Austria": "Austria",
  "Belarus": "Belarus",
  "Belgium": "Belgium",
  "Herzegovina": "Herzegovina",
  "Bulgaria": "Bulgaria",
  "Croatia": "Croatia",
  "Cyprus": "Cyprus",
  "Czech": "Czech",
  "Denmark": "Denmark",
  "Estonia": "Estonia",
  "Finland": "Finland",
  "France": "France",
  "Germany": "Germany",
  "Greece": "Greece",
  "Hungary": "Hungary",
  "Iceland": "Iceland",
  "Ireland": "Ireland",
  "Italy": "Italy",
  "Latvia": "Latvia",
  "Lithuania": "Lithuania",
  "Luxembourg": "Luxembourg",
  "Moldova": "Moldova",
  "Netherlands": "Netherlands",
  "Norway": "Norway",
  "Poland": "Poland",
  "Romania": "Romania",
  "Russia": "Russia",
  "Serbia": "Serbia",
  "Slovakia": "Slovakia",
  "Slovenia": "Slovenia",
  "Spain": "Spain",
  "Sweden": "Sweden",
  "Swiss": "Switzerland",
  "Tunisia": "Tunisia",
  "Turkey": "Turkey",
  "UK": "United Kingdom",
  "United_States": "United States",
  "Ukraine": "Ukraine",
  "Montenegro": "Montenegro",
  "Liechtenstein": "Liechtenstein",
  "Monaco": "Monaco",
  "Vatican": "Vatican",
  "San_Marino": "San Marino",
  "Kosovo": "Kosovo",
  "Indonesia": "Indonesia",
  "Japan": "Japan",
  "Malaysia": "Malaysia",
  "Philippines": "Philippines",
  "Viet_Nam": "Vietnam",
  "Bangladesh": "Bangladesh",
  "Cambodia": "Cambodia",
  "China": "China",
  "India": "India",
  "Korea": "South Korea",
  "Laos": "Laos",
  "Tajikistan": "Tajikistan",
  "Thailand": "Thailand",
  "Singapore": "Singapore",
  "Taiwan": "Taiwan",
  "Australia": "Australia",
  "New_Zealand": "New Zealand"
};

const BACKEND_TO_DISPLAY_STATE = {
  "ALABAMA": "Alabama",
  "ALASKA": "Alaska",
  "ARIZONA": "Arizona",
  "ARKANSAS": "Arkansas",
  "CALIFORNIA": "California",
  "COLORADO": "Colorado",
  "CONNECTICUT": "Connecticut",
  "DELAWARE": "Delaware",
  "FLORIDA": "Florida",
  "GEORGIA": "Georgia",
  "HAWAII": "Hawaii",
  "IDAHO": "Idaho",
  "ILLINOIS": "Illinois",
  "INDIANA": "Indiana",
  "IOWA": "Iowa",
  "KANSAS": "Kansas",
  "KENTUCKY": "Kentucky",
  "LOUISIANA": "Louisiana",
  "MAINE": "Maine",
  "MARYLAND": "Maryland",
  "MASSACHUSETTS": "Massachusetts",
  "MICHIGAN": "Michigan",
  "MINNESOTA": "Minnesota",
  "MISSISSIPPI": "Mississippi",
  "MISSOURI": "Missouri",
  "MONTANA": "Montana",
  "NEBRASKA": "Nebraska",
  "NEVADA": "Nevada",
  "NEW_HAMPSHIRE": "New Hampshire",
  "NEW_JERSEY": "New Jersey",
  "NEW_YORK": "New York",
  "NORTH_CAROLINA": "North Carolina",
  "NORTH_DAKOTA": "North Dakota",
  "OHIO": "Ohio",
  "OKLAHOMA": "Oklahoma",
  "OREGON": "Oregon",
  "PENNSYLVANIA": "Pennsylvania",
  "RHODE_ISLAND": "Rhode Island",
  "SOUTH_CAROLINA": "South Carolina",
  "SOUTH_DAKOTA": "South Dakota",
  "TENNESSEE": "Tennessee",
  "TEXAS": "Texas",
  "UTAH": "Utah",
  "VERMONT": "Vermont",
  "VIRGINIA": "Virginia",
  "WASHINGTON": "Washington",
  "WEST_VIRGINIA": "West Virginia",
  "WISCONSIN": "Wisconsin",
  "WYOMING": "Wyoming",
  "WASHINGTON_D_C": "Washington D.C."
};

// Función para convertir país del backend a formato de display
const formatCountryForDisplay = (backendCountry) => {
  if (!backendCountry) return "";
  return BACKEND_TO_DISPLAY_COUNTRY[backendCountry] || backendCountry;
};

// Función para convertir estado del backend a formato de display
const formatStateForDisplay = (backendState) => {
  if (!backendState) return "";
  return BACKEND_TO_DISPLAY_STATE[backendState] || backendState;
};

const EditAddresesses = ({ current_user }) => {
  const { data, loading } = useQuery(GET_ADDRESS_BY_ID, {
    variables: { id: parseInt(current_user.id) },
  });

  const [typeModal, setTypeModal] = useState("");
  const [modalAddress, setModalAddress] = useState(false);

  const [address, setAddress] = useState({
    user: current_user.id,
  });
  const [positionRow, setPositionRow] = useState("");
  
  const handleModalAddress = (typeModal, row, position) => {
    setTypeModal(typeModal);
    if (typeModal === "edit") {
      setPositionRow(position);
      setAddress(row);
    } else {
      setAddress({
        user: current_user.id,
        address: "",
      });
    }
    setModalAddress(true);
  };
  
  return (
    <div className="container">
      {loading && <Loading />}
      <ContainerPage>
        <h2>My Addresses</h2>
        <div className="container-full u-margin-top-1">
          {data?.addresses.data.length === 0 ? (
            <div className="u-text-center no-address-found">
              <FaRegAddressBook />
              <p>No addresses found</p>
              <button
                onClick={() => handleModalAddress("add", null)}
                className=""
              >
                Add your first address
              </button>
            </div>
          ) : (
            <div className="container-full">
              <div className="row">
                <div
                  className="col-12"
                  style={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "space-between",
                  }}
                >
                  <button
                    onClick={() => handleModalAddress("add", null)}
                    className="u-margin-tb-1 btn btn-primary u-size-btn"
                  >
                    Add a New Address
                  </button>
                </div>

                {data?.addresses.data.map((addressRow, i) => (
                  <div className="col-lg-6" key={i}>
                    <div className="container">
                      <Row className="row border-top">
                        <CardAddress className="col-lg-8 col-md-8">
                          <TextAddress>
                            {addressRow.attributes.firstname}{" "}
                            {addressRow.attributes.lastname}
                          </TextAddress>
                          <TextAddress>
                            {addressRow.attributes.street}{", "}
                            {addressRow.attributes.aptNumber}{", "}
                            {addressRow.attributes.cityName}{", "}
                            {addressRow.attributes.Country ? formatCountryForDisplay(addressRow.attributes.Country) + " " : ""}
                            {addressRow.attributes.zipcode}{" "}
                            {addressRow.attributes.State ? formatStateForDisplay(addressRow.attributes.State) + " " : ""}
                          </TextAddress>
                          <TextAddress>
                            {addressRow.attributes.phone}
                          </TextAddress>
                        </CardAddress>
                        <ButtonChange className="col-lg-4 col-md-4">
                          <button
                            onClick={() =>
                              handleModalAddress(
                                "edit",
                                addressRow.attributes,
                                addressRow.id
                              )
                            }
                            className="btn btn-danger u-size-btn"
                          >
                            Change
                          </button>
                        </ButtonChange>
                      </Row>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          )}
        </div>
      </ContainerPage>

      <ModalAddress
        mainAddress={data?.addresses.data.length}
        positionRow={positionRow}
        typeModal={typeModal}
        address={address}
        openModal={modalAddress}
        setAddress={setAddress}
        onCancel={() => {
          setModalAddress(false);
        }}
        setModalAddress={setModalAddress}
      />
    </div>
  );
};

export default EditAddresesses;